let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9d2MG")).then(() => parcelRequire('hK0fV'));